import { type LoaderFunctionArgs } from 'react-router';
import store from '../../store';
import { getServices } from '../../reducers/services/servicesReducer';
import {
  clearAvailableTimeSlots,
  resetTimeSlotsFromDate,
} from '../../reducers/timeslots/timeSlotsReducer';
import { clearAvailableStores } from '../../reducers/stores/storesReducer';
import {
  clearSelectedStore,
  updatePage,
  updateSelectedService,
} from '../../reducers/app/appReducer';
import type { AvailableService } from '../../services/appointment/model';
import { viewContext } from '../middleware/context';

export const loadServices = async (
  operation: string,
): Promise<AvailableService[]> => {
  const postalCode = store.getState().search.postCode;
  const stateCode = store.getState().search.state || '';
  const customerType = store.getState().user.customerType;
  const allowedMemberDiscounts = store.getState().user.allowedMemberDiscounts;
  const selectedServiceId = store.getState().app.selected.serviceId;

  let services: AvailableService[] = [];
  try {
    services = await store
      .dispatch(
        getServices({
          customerType,
          allowedMemberDiscounts,
          zipCode: postalCode || '',
          operation,
          stateCode,
        }),
      )
      .unwrap();

    const selectedService = services.find(
      (service) => service.serviceId === selectedServiceId,
    );

    if (!selectedService) {
      store.dispatch(updateSelectedService());
    }
  } catch (error) {
    store.dispatch(updateSelectedService());
  }
  return services;
};

const loader = async (args: LoaderFunctionArgs) => {
  const { params, request, context } = args;
  const view = context.get(viewContext);
  const url = new URL(request.url);
  const operation =
    view === 'app' && url.pathname.includes('/ikeaapp/')
      ? 'ikeaapp'
      : params.operation || '';
  store.dispatch(updatePage('services'));
  await loadServices(operation);
  store.dispatch(resetTimeSlotsFromDate());
  store.dispatch(clearSelectedStore());
  store.dispatch(clearAvailableStores());
  store.dispatch(clearAvailableTimeSlots());
};

export default loader;
